import axios from 'axios';
import { hankakuToZenkaku } from '../util/util';
import tingle from 'tingle.js';

const $officePostcode = $('[id^=form_job_entry_form_postcode]');
const $addressCity = $('[id$=address]');
const zipcodeModal = new tingle.modal({
  closeMethods: ['overlay','escape'],
  cssClass: ['tingle-custom-modal']
});
let zipcodeValue = '';

$officePostcode.on('keyup', (e) => {
  const value = $(e.target).val();
  onFetchZip(hankakuToZenkaku(value));
});

$officePostcode.on('blur', (e) => {
  const $target = $(e.target);
  const value = $target.val();
  $target.val(hankakuToZenkaku(value, "-"));
});

$(document).on('click', '.js-addressList .selectAddress', (e) => {
  e.preventDefault();
  $addressCity.val(e.target.innerText);
  zipcodeModal.close();
});

const getAddressStr = (data) => {
  return `${data.prefecture}${data.city}${data.town}${data.koaza}${data.kyoto_street}`;
}

const insertAddress = (data) => {
  if (data.length === 1){
    $addressCity.val(getAddressStr(data[0]));
    return;
  }

  let modalContent = '<p>郵便番号に対応する住所が複数ございます。入力したい住所を選択してください。</p>'
                   + '<div class="js-addressList">'
  for (const i in data) {
    modalContent += '<div class="addressItem"><a href="#" class="selectAddress">'
                 + getAddressStr(data[i])
                 + '</a></div>';
  }
  modalContent += '</div>';
  zipcodeModal.setContent(modalContent);
  zipcodeModal.open();
}

const onFetchZip = (value) => {
  if(zipcodeValue === value) {
    return;
  }
  zipcodeValue = value;

  if(value.match(/^[0-9]{7}$/g)) {
    axios({
      url: `/api/v1/kenall_postalcode/${value}`
    }).then(({ data: { data } }) => {
      if (data.data[0]) {
        insertAddress(data.data);
      }
    });
  }
  return value;
}
